import { CloseIcon } from "components/icons"
import { SearchPopupContent as BaseSearchPopupContent } from "../SearchPopupContent"
import { FilterVenueRadioButtons } from "./FilterVenueRadioButtons"
import { DirectoryOccupantCard } from "components/domains/directory/DirectoryOccupantCard"
import { DirectorySkeletonCard } from "components/domains/directory"
import { VenueSelector } from "components/VenueSelector"
import { useVenue } from "providers/venue"

export const SearchPopupContent = (props) => {
  const { setVenueFilter, venueFilter, searchResultProps, ...restProps } = props
  const { venues = [] } = useVenue()
  return (
    <BaseSearchPopupContent
      {...restProps}
      closeIcon={CloseIcon}
      searchResultProps={{
        ...searchResultProps,
        renderSearchItem: DirectoryOccupantCard,
        renderLoadingItem: DirectorySkeletonCard,
      }}
      searchBasePopupProps={{
        dialogProps: { disablePortal: true, hideBackdrop: false },
      }}
      searchKeyboardProps={{
        topKeywordAdornment: (
          <FilterVenueRadioButtons
            onChange={setVenueFilter}
            value={venueFilter}
          />
        ),
      }}
      venueFilterComponent={
        <VenueSelector
          selectedVenue={venueFilter}
          onClickVenue={setVenueFilter}
          venues={venues}
        />
      }
    />
  )
}
